import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  LOAD_ZONE_LIST,
  CREATE_ZONE,
  EDIT_ZONE_BY_ID,
  LOAD_ZONE_BY_ID,
  DELETE_ZONE,
  EXPORT_GEOGRAPHY, IMPORT_GEOGRAPHY, LOAD_ZONE_HISTORY, LOAD_HISTORY_BY_ID,
} from './actions';
import { GEOGRAPHY_MODULE } from '../../configs/moduleNames';
import {
  createLoadByIdReducer,
  createLoadListReducerWithBegin,
  createOperationStateReducer,
  updateLoadParameterReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  geographyListMeta: {},
  loadingGeographyList: false,
  geographyList: [],
  loadingCurrentGeography: false,
  currentGeography: {},
  loadingCreateGeography: false,
  loadingEditGeographyById: false,
  loadingDeleteGeography: false,
  loadingExportGeography: false,
  loadingImportGeography: false,
  geographyHistoryMeta: {},
  loadingGeographyHistory: false,
  geographyHistory: [],
  loadingCurrentHistory: false,
  currentHistory: {},
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(GEOGRAPHY_MODULE + LOAD_ZONE_LIST, 'geographyList', 'loadingGeographyList'),
  ...updateLoadParameterReducer(GEOGRAPHY_MODULE + LOAD_ZONE_BY_ID, 'currentGeography', 'loadingCurrentGeography', {}),
  ...createOperationStateReducer(GEOGRAPHY_MODULE + CREATE_ZONE, 'loadingCreateGeography'),
  ...createOperationStateReducer(GEOGRAPHY_MODULE + EDIT_ZONE_BY_ID, 'loadingEditGeographyById'),
  ...createOperationStateReducer(GEOGRAPHY_MODULE + DELETE_ZONE, 'loadingDeleteGeography'),
  ...createOperationStateReducer(GEOGRAPHY_MODULE + EXPORT_GEOGRAPHY, 'loadingExportGeography'),
  ...createOperationStateReducer(GEOGRAPHY_MODULE + IMPORT_GEOGRAPHY, 'loadingImportGeography'),
  ...createLoadListReducerWithBegin(GEOGRAPHY_MODULE + LOAD_ZONE_HISTORY, 'geographyHistory', 'loadingGeographyHistory'),
  ...createLoadByIdReducer(GEOGRAPHY_MODULE + LOAD_HISTORY_BY_ID, 'currentHistory', 'loadingCurrentHistory'),
}, initialState);

export default reducer;

export const getGeographyData = createSelector(
  [state => state[GEOGRAPHY_MODULE]],
  state => {
    const {
      geographyListMeta,
      loadingGeographyList,
      geographyList,
      loadingCurrentGeography,
      currentGeography,
      loadingCreateGeography,
      loadingEditGeographyById,
      loadingDeleteGeography,
      loadingExportGeography,
      loadingImportGeography,
      geographyHistoryMeta,
      loadingGeographyHistory,
      geographyHistory,
      loadingCurrentHistory,
      currentHistory,
    } = state;
    return {
      geographyListMeta,
      loadingGeographyList,
      geographyList,
      loadingCurrentGeography,
      currentGeography,
      loadingCreateGeography,
      loadingEditGeographyById,
      loadingDeleteGeography,
      loadingExportGeography,
      loadingImportGeography,
      geographyHistoryMeta,
      loadingGeographyHistory,
      geographyHistory,
      loadingCurrentHistory,
      currentHistory,
    };
  },
);
